/**
 * Customer Portal (UI) - direct B2B dashboard variant.
 */
import type { DashboardResponse } from '../../types/portal';
import { MetricCardsGrid } from './MetricCardsGrid';

type DirectB2BDashboardProps = {
  dashboard: DashboardResponse;
};

export function DirectB2BDashboard({ dashboard }: DirectB2BDashboardProps) {
  return (
    <div className="row row-cards">
      <div className="col-12">
        <MetricCardsGrid
          title="Direct Account Performance"
          description="Core account messaging KPIs across outbound and inbound traffic."
          metrics={dashboard.metrics}
        />
      </div>
    </div>
  );
}
